import { DropdownFieldLink } from '@cian/components';
import * as React from 'react';

import { EPriceType } from '../../../json_query';

const style = require('./index.css');

export const salePriceTypeMap = {
  [EPriceType.SM]: 'за м\u00B2',
  [EPriceType.Total]: 'за всё',
};

export const rentPriceTypeMap = {
  [EPriceType.SM]: 'за м\u00B2 в год',
  [EPriceType.Total]: 'за месяц',
};

export interface IPriceTypeSelectProps {
  priceType: EPriceType;
  isSaleDealType: boolean;
  onPriceTypeChanged(priceType: EPriceType): void;
}

export class PriceTypeSelect extends React.Component<IPriceTypeSelectProps> {
  public render() {
    const props = this.props;
    const priceTypeMap = props.isSaleDealType ? salePriceTypeMap : rentPriceTypeMap;

    return (
      <DropdownFieldLink
        buttonStyle={style.priceType}
        value={props.priceType}
        onValueChange={(value: EPriceType) => props.onPriceTypeChanged(value)}
        values={[
          { value: EPriceType.SM, label: priceTypeMap[EPriceType.SM] },
          { value: EPriceType.Total, label: priceTypeMap[EPriceType.Total] },
        ]}
      />
    );
  }
}
